import React, { Component } from 'react';
import css from '../ProjectPage/ProjectPage.module.scss';
import Header from '../ProjectPage/Header';
import ProjectItem from '../ProjectItem.js';

import ImgY1 from './assets/Y1.png';
import ImgY2 from './assets/Y2.png';

import ImgTwitch from '../assets/Twitch.png';
import ImgGnostMono from '../assets/GnostMono.png';

export default class YNABTwitch extends Component {

  render () {
      return (
        <div className={css.projectPage}>
          <Header
            title='YNAB x Twitch Core UI'
            year='2020'
            exploration='Spec Redesign'
          />
          <div className={css.content}>
            <img src={ImgY1} alt='YNAB Core UI Redesign' />
            <div className={css.text}>
              <p>Twitch Design hosted a friendly competition to redesign our favourite apps using our component library, CoreUI. Since I’m a huge fan of YNAB, my submission was a redesign of YNAB’s primary interface, and I won second place!</p>
            </div>
            <img src={ImgY2} alt='Core UI Design Fridays Winners' />
          </div>
          <div className={css.moreWork}>
            <header>More Projects</header>
              <ul className={css.moreWorkList}>
                <ProjectItem
                  title='Gnost Mono'
                  description='Mono spaced type design'
                  exploration='Type Design'
                  img={ImgGnostMono}
                  link='GnostMono'
                />
                <ProjectItem
                  title='Twitch'
                  description='Positioning Twitch as the premier destination for mobile gamers'
                  position='Senior Product Designer'
                  img={ImgTwitch}
                  link='Twitch'
                />
              </ul>
          </div>
        </div>
      )
   }
}
